:host {
/**
  * @prop --action-icon-color: Color of the icon
  * @prop --text-color: Color of the text
  * @prop --background-color: Color of the background
  * @prop --font-family: Font used for the description
  * @prop --spacing: Spacing used between the icon and the text
  * @prop --line-height: Line-height used to determine the size of the icon and the text
  * @prop --font-size: Size of the font
  * @prop --font-weight: Weight of the font
  */

  --action-icon-color: var(--s-color-icon-variant);
  --text-color: var(--s-color-text-default);
  --background-color: 'transparent';
  --font-family: var(--s-font-family-paragraph);
  --font-weight: var(--s-font-weight-paragraph-default);
  --line-height: var(--p-size-dynamic-300);
  --font-size: var(--s-size-text-default);
  --spacing: var(--p-size-static-100);
  .action-description {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 0;
    ::slotted([slot|='icon']) {
      display: none;
      margin-right: var(--spacing);
    }
    ::slotted([slot|="action"]) {
      line-height: var(--line-height);
      font-size: var(--font-size);
      font-family: var(--font-family);
    }
  }
  .show-icon {
    ::slotted([slot|='icon']) {
      display: inline-flex;
      --size: var(--line-height);
      --icon-color: var(--action-icon-color);
    }
  }
}
